package com.anjuros.website.templates.template1.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template1.modules.Template1Review
import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template1.util.Template1Constants.FONT_FAMILY
import com.anjuros.website.templates.template1.util.Template1Res
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.FlexDirection.Companion.Row
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template1TestimonialCard(
    modifier: Modifier=Modifier,
    testimonial: Template1Review){

    Row(modifier= modifier
        .maxWidth(500.px)){


        Column {
            Row(modifier=Modifier
                .fillMaxWidth()
                .margin(bottom = 10.px)) {

                Column {
                    P(
                        attrs = Modifier
                            .fillMaxWidth()
                            .margin(topBottom = 0.px)
                            .fontFamily(FONT_FAMILY)
                            .fontSize(18.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Template1Theme.Secondary.rgb)
                            .toAttrs()
                    ) {
                        Text(LocalText(testimonial.title))
                    }

                    RatingBar(modifier=Modifier.margin(top=5.px))

                }

            }

            P(
                attrs = Modifier
                    .fillMaxWidth()
                    .margin(topBottom = 0.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .fontWeight(FontWeight.Normal)
                    .fontStyle(FontStyle.Italic)
                    .color(Template1Theme.Secondary.rgb)
                    .toAttrs()
            ) {
                Text(LocalText(testimonial.review))
            }

        }
    }
}

@Composable
fun RatingBar(modifier: Modifier=Modifier){
    Row(modifier=modifier){
        repeat(5){
            Image(
                modifier = Modifier
                    .size(16.px)
                    .margin(right=if(it!=4) 2.px else 0.px),
                src = Template1Res.Icon.star,
                alt = "Star icon"
            )
        }
    }
}